import React, { lazy, memo } from 'react';
const SplitSections = () => {
  return <section className="py-20 bg-white" data-id="element-815">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-816">
        <div className="text-center mb-16" data-id="element-817">
          <h2 className="text-3xl font-bold text-navy-950 sm:text-4xl" data-id="element-818">
            Premium Showroom Beverage Solutions
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-819">
            Tailored beverage experiences that elevate customer engagement,
            enhance brand perception, and drive sales conversions
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20" data-id="element-820">
          <div data-id="element-821">
            <h3 className="text-2xl font-bold text-navy-950 mb-6" data-id="element-822">
              Elevate the Customer Experience
            </h3>
            <ul className="space-y-4" data-id="element-823">
              <li className="flex" data-id="element-824">
                <div className="flex-shrink-0" data-id="element-825">
                  <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-826">
                    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-827">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-828" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4" data-id="element-829">
                  <h4 className="text-lg font-medium text-navy-950" data-id="element-830">
                    Premium Welcome Experience
                  </h4>
                  <p className="mt-2 text-gray-600" data-id="element-831">
                    Create a memorable first impression with personalized
                    premium beverages that set the tone for a luxury shopping
                    experience.
                  </p>
                </div>
              </li>
              <li className="flex" data-id="element-832">
                <div className="flex-shrink-0" data-id="element-833">
                  <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-834">
                    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-835">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-836" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4" data-id="element-837">
                  <h4 className="text-lg font-medium text-navy-950" data-id="element-838">
                    Comfortable Browsing Environment
                  </h4>
                  <p className="mt-2 text-gray-600" data-id="element-839">
                    Keep customers refreshed and comfortable as they explore
                    your showroom, extending their visit duration and increasing
                    engagement.
                  </p>
                </div>
              </li>
              <li className="flex" data-id="element-840">
                <div className="flex-shrink-0" data-id="element-841">
                  <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-842">
                    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-843">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-844" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4" data-id="element-845">
                  <h4 className="text-lg font-medium text-navy-950" data-id="element-846">
                    Customizable Refreshment Options
                  </h4>
                  <p className="mt-2 text-gray-600" data-id="element-847">
                    Offer a wide variety of premium beverages that can be
                    tailored to your customer demographics and brand
                    positioning.
                  </p>
                </div>
              </li>
            </ul>
          </div>
          <div data-id="element-848">
            <div className="relative rounded-2xl overflow-hidden shadow-xl h-80 lg:h-96" data-id="element-849">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6VdDKdAcKT38BXoFFKcoLd/Elementary_5.webp" alt="Elementary school students with teacher enjoying SmartSoda healthy beverages in bright classroom setting" className="w-full h-full object-cover object-center" width="600" height="400" loading="lazy" decoding="async" data-id="element-850" />
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20" data-id="element-851">
          <div className="order-2 lg:order-1" data-id="element-852">
            <div className="relative rounded-2xl overflow-hidden shadow-xl h-80 lg:h-96" data-id="element-853">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wTUHD7HYz59D2RkehnsJU8/Elementary_4.webp" alt="Elementary students filling reusable bottles at SmartSoda station in school hallway" className="w-full h-full object-cover object-center" width="600" height="400" loading="lazy" decoding="async" data-id="element-854" />
            </div>
          </div>
          <div className="order-1 lg:order-2" data-id="element-855">
            <h3 className="text-2xl font-bold text-navy-950 mb-6" data-id="element-856">
              Enhance Sales Conversations
            </h3>
            <ul className="space-y-4" data-id="element-857">
              <li className="flex" data-id="element-858">
                <div className="flex-shrink-0" data-id="element-859">
                  <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-860">
                    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-861">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-862" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4" data-id="element-863">
                  <h4 className="text-lg font-medium text-navy-950" data-id="element-864">
                    Meaningful Customer Connections
                  </h4>
                  <p className="mt-2 text-gray-600" data-id="element-865">
                    Create a relaxed atmosphere where sales consultants can
                    build rapport with customers over premium beverages,
                    facilitating more natural conversations.
                  </p>
                </div>
              </li>
              <li className="flex" data-id="element-866">
                <div className="flex-shrink-0" data-id="element-867">
                  <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-868">
                    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-869">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-870" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4" data-id="element-871">
                  <h4 className="text-lg font-medium text-navy-950" data-id="element-872">
                    Extended Engagement Time
                  </h4>
                  <p className="mt-2 text-gray-600" data-id="element-873">
                    Keep customers comfortable and engaged in your showroom
                    longer, providing more opportunities to showcase products
                    and close sales.
                  </p>
                </div>
              </li>
              <li className="flex" data-id="element-874">
                <div className="flex-shrink-0" data-id="element-875">
                  <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-876">
                    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-877">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-878" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4" data-id="element-879">
                  <h4 className="text-lg font-medium text-navy-950" data-id="element-880">
                    Negotiation Environment
                  </h4>
                  <p className="mt-2 text-gray-600" data-id="element-881">
                    Create a comfortable setting for price discussions and
                    financing conversations, helping customers feel relaxed
                    during decision-making moments.
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20" data-id="element-882">
          <div data-id="element-883">
            <h3 className="text-2xl font-bold text-navy-950 mb-6" data-id="element-884">
              Strengthen Your Brand Image
            </h3>
            <ul className="space-y-4" data-id="element-885">
              <li className="flex" data-id="element-886">
                <div className="flex-shrink-0" data-id="element-887">
                  <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-888">
                    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-889">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-890" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4" data-id="element-891">
                  <h4 className="text-lg font-medium text-navy-950" data-id="element-892">
                    Elevated Perception
                  </h4>
                  <p className="mt-2 text-gray-600" data-id="element-893">
                    Enhance your brand's premium positioning with sophisticated
                    beverage offerings that reflect your commitment to
                    excellence in every detail.
                  </p>
                </div>
              </li>
              <li className="flex" data-id="element-894">
                <div className="flex-shrink-0" data-id="element-895">
                  <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-896">
                    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-897">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-898" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4" data-id="element-899">
                  <h4 className="text-lg font-medium text-navy-950" data-id="element-900">
                    Sustainability Leadership
                  </h4>
                  <p className="mt-2 text-gray-600" data-id="element-901">
                    Showcase your environmental commitment by eliminating
                    single-use plastics while enhancing the premium nature of
                    your customer experience.
                  </p>
                </div>
              </li>
              <li className="flex" data-id="element-902">
                <div className="flex-shrink-0" data-id="element-903">
                  <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-904">
                    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-905">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-906" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4" data-id="element-907">
                  <h4 className="text-lg font-medium text-navy-950" data-id="element-908">
                    Memorable Brand Touchpoint
                  </h4>
                  <p className="mt-2 text-gray-600" data-id="element-909">
                    Create a distinctive element of your customer experience
                    that sets you apart from competitors and becomes part of
                    your brand identity.
                  </p>
                </div>
              </li>
            </ul>
          </div>
          <div data-id="element-910">
            <div className="relative rounded-2xl overflow-hidden shadow-xl h-80 lg:h-96" data-id="element-911">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jN9JGv87Ex5StjuYCSpVyZ/Elementary_3.webp" alt="Elementary students and teacher learning about healthy hydration choices with SmartSoda in classroom" className="w-full h-full object-cover object-center" width="600" height="400" loading="lazy" decoding="async" data-id="element-912" />
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-913">
          <div className="order-2 lg:order-1" data-id="element-914">
            <div className="relative rounded-2xl overflow-hidden shadow-xl h-80 lg:h-96" data-id="element-915">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vdKu2Y1dJKQd1jmNAhGVG8/High_School_2.webp" alt="High school students socializing with SmartSoda beverages in modern school common area" className="w-full h-full object-cover object-center" width="600" height="400" loading="lazy" decoding="async" data-id="element-916" />
            </div>
          </div>
          <div className="order-1 lg:order-2" data-id="element-917">
            <h3 className="text-2xl font-bold text-navy-950 mb-6" data-id="element-918">
              Seamless Integration Into Your Showroom
            </h3>
            <ul className="space-y-4" data-id="element-919">
              <li className="flex" data-id="element-920">
                <div className="flex-shrink-0" data-id="element-921">
                  <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-922">
                    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-923">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-924" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4" data-id="element-925">
                  <h4 className="text-lg font-medium text-navy-950" data-id="element-926">
                    Elegant Design
                  </h4>
                  <p className="mt-2 text-gray-600" data-id="element-927">
                    Our sleek, modern dispensing systems blend seamlessly with
                    your showroom aesthetic and can be customized to match your
                    brand environment.
                  </p>
                </div>
              </li>
              <li className="flex" data-id="element-928">
                <div className="flex-shrink-0" data-id="element-929">
                  <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-930">
                    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-931">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-932" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4" data-id="element-933">
                  <h4 className="text-lg font-medium text-navy-950" data-id="element-934">
                    Versatile Placement Options
                  </h4>
                  <p className="mt-2 text-gray-600" data-id="element-935">
                    Position systems in reception areas, consultation spaces, or
                    alongside your premium products to enhance the customer
                    journey at key moments.
                  </p>
                </div>
              </li>
              <li className="flex" data-id="element-936">
                <div className="flex-shrink-0" data-id="element-937">
                  <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-938">
                    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-939">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-940" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4" data-id="element-941">
                  <h4 className="text-lg font-medium text-navy-950" data-id="element-942">
                    Staff-Friendly Operation
                  </h4>
                  <p className="mt-2 text-gray-600" data-id="element-943">
                    Intuitive touchscreen interface and minimal maintenance
                    requirements allow your team to focus on what matters
                    most—serving customers and closing sales.
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-16 text-center" data-id="element-944">
          <a href="#book-demo" className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-base font-medium rounded-lg shadow-md text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all" data-id="element-945">
            Transform Your Showroom Experience
          </a>
        </div>
      </div>
    </section>;
};
export default SplitSections;